var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 189",
    d: "M14.726 12.8218L17.4113 15.6564C17.7415 16.0049 17.7415 16.5507 17.4113 16.8992C15.4803 18.9375 12.3124 19.164 10.111 17.4212L8.57254 16.2033C6.86615 14.8524 5.36014 13.2661 4.09956 11.492L2.77491 9.62765C1.16244 7.35825 1.38027 4.26527 3.2949 2.24427C3.678 1.83989 4.322 1.83989 4.7051 2.24427L7.34845 5.03448C7.71385 5.42017 7.71385 6.02427 7.34845 6.40997L6.26371 7.55497C6.10475 7.72277 6.0652 7.97098 6.16415 8.17987L6.23833 8.33648C7.38192 10.7507 9.2769 12.7295 11.6394 13.9764C11.8526 14.0889 12.1146 14.0457 12.2804 13.8707L13.274 12.8218C13.6685 12.4055 14.3315 12.4055 14.726 12.8218Z",
    stroke: "white",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.36139ec6958ed7b1bcf2c1bc92901ebe.svg";
export { ForwardRef as ReactComponent };